import { Button, Modal, Paragraph, tokens } from '@welbe/web-design-system';
import { useMemo } from 'react';
import { Iframe, TitleContainer } from './FilePreview.styles';

type FilePreviewProps = {
	file: File;
	isVisible: boolean;
	onClose: () => void;
};

export const FilePreview = ({
	file,
	isVisible,
	onClose,
}: FilePreviewProps): JSX.Element => {
	const shortenFileName = useMemo(() => {
		const MAX_LENGTH = 50;

		if (file.name.length <= MAX_LENGTH) {
			return file.name;
		}

		const parts = file.name.split('.');
		const extension = parts.pop();
		const baseName = parts.join('.');

		const prefixLength = Math.floor((MAX_LENGTH - 3) / 2);
		const sufixLength = MAX_LENGTH - 3 - prefixLength;

		return `${baseName.slice(0, prefixLength)}...${baseName.slice(
			-sufixLength,
		)}.${extension}`;
	}, [file]);

	return (
		<Modal
			id="file-preview"
			open={isVisible}
			width="100vw"
			maxWidth="100%"
			height="100vh"
			borderRadius="0"
			background="transparent"
			preventBackdropClose
		>
			<TitleContainer>
				<Paragraph title={file.name} elipsis color={tokens.color_white}>
					{shortenFileName}
				</Paragraph>
				<Button width="184px" onClick={onClose}>
					Cerrar
				</Button>
			</TitleContainer>
			<Iframe src={URL.createObjectURL(file)} />
		</Modal>
	);
};
